<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="replacementBills"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <!--        <el-button type="primary" :disabled="!selection.length" @click="printHandle"> 打印 </el-button>-->
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </el-form-item>
          <el-form-item label="OA流程编号">
            <el-input v-model.trim="filter.oaProcessNumber" placeholder="请输入OA流程编号" clearable/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="全部" value="-1"/>
              <el-option label="草稿" value="0"/>
              <el-option label="待审核" value="1"/>
              <el-option label="质量已审核" value="2"/>
              <el-option label="已驳回" value="3"/>
              <el-option label="已通过" value="4"/>
            </el-select>
          </el-form-item>
          <el-form-item label="退货类型">
            <el-select v-model="filter.type" clearable placeholder="请选择退货类型">
              <el-option label="全部" value="-1"/>
              <el-option label="退货" value="0"/>
              <el-option label="换货" value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="退货原因">
            <el-select v-model="filter.orderReturnReason" clearable placeholder="请选择退货原因">
              <el-option label="全部" value="-1"/>
              <el-option label="质量原因" value="0"/>
              <el-option label="客户原因" value="1"/>
              <el-option label="服务机原因" value="2"/>
              <el-option label="技术升级" value="3"/>
            </el-select>
          </el-form-item>
          <el-form-item label="退货事由">
            <el-select v-model="filter.returnReason" clearable placeholder="请选择退货事由">
              <el-option label="全部" value="-1"/>
              <el-option label="样机退货" value="0"/>
              <el-option label="订单退货" value="1"/>
              <el-option label="服务机退货" value="2"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :disabled="scope.row.status !== 0 && scope.row.status !== 3"
            :loading="submitLoading"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.changeAuth"
            type="primary"
            :disabled="scope.row.status === 0 || scope.row.status === 3 || scope.row.isAddSalesOrder === true"
            :loading="submitLoading"
            @click="addSalesOrder(scope.row.pkid)">
          转销单
        </el-button>
      </template>
    </viewTable>
    <replacement-bill-edit ref="replacementBillEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ReplacementBillEdit from "@/views/AfterSaleManage/ReplacementBill/ReplacementBillEdit";

  export default {
    name: "ReplacementBillList",
    components: {ReplacementBillEdit, viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(560),
          editAuth: this.$auth(561),
          delAuth: this.$auth(563),
          subAuth: this.$auth(562),
          changeAuth: this.$auth(564),
        },
        submitLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          oaProcessNumber: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: "",
          type: "",
          returnReason: "",
          orderReturnReason: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/ReplacementBillPreview",
                        query: {
                          billType: 13,
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
            key: "customerName",
            align: "center",
            width: 210,
          },
          {
            key: "orderReturnReasonName",
            align: "center",
            width: 120,
          },
          {
            key: "typeName",
            align: "center",
            width: 120,
          },
          {
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.replacementBillEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `replacementBills/submitOA/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      addSalesOrder(pkid) {
        this.$confirm("确定转销售订单吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `replacementBills/addSalesOrder/${pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("操作成功！");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "replacementBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      otherAuth(row) {
        // 待审核(1)和已通过(4)状态不能删除，返回true禁用删除按钮
        return row.status === 1 || row.status === 4;
      },
    },
  };
</script>
